

import { ResponseType } from "../../Types/ServicesType/servicesType";
import { editPostOficeType,PostOfficeListType } from "./types";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId} = getConstants()
const {SettingsApi} = api
export const getPostOfficeTableData = async ():Promise<ResponseType<PostOfficeListType[]>>=>{
    const result = await instance.get(`${SettingsApi.getPostOffice}${clinicId}`);
    return result.data;
}

export const editPostOfficeService = async (params:editPostOficeType):Promise<ResponseType<string | null>>=>{
    const result = await instance.post(`${SettingsApi.editPostOffice}`,params);
    return result.data;
}